export default {
  data() {
    return {
      pxToEmCache: {},
    }
  },
  methods: {
    pxToEm(pxValue) {
      // Check if the value is already in the cache
      if (this.pxToEmCache[pxValue]) {
        return this.pxToEmCache[pxValue]
      }

      const numericPxValue = parseFloat(pxValue)
      const result = `${numericPxValue / 16}em`

      // Store the result in the cache before returning it
      this.pxToEmCache[pxValue] = result
      return result
    },
  },
  computed: {
    emStyling() {
      const stylingSource = this.widget ? this.widget.styling : this.component.styling;
      return Object.keys(stylingSource).reduce((acc, key) => {
        const value = stylingSource[key]
        acc[key] = typeof value === 'string' && value.includes('px')
          ? this.pxToEm(value)
          : value
        return acc
      }, {})
    },
  },
}